import { CheckboxWrapper } from 'components/formInputs/wrappers/checkboxWrapper';
import { TextboxWrapper } from 'components/formInputs/wrappers/textboxWrapper';
import React, { useState } from 'react';

const EditDataColumn = ({ item, editSettings, onEdit }) => {
  const [value, setValue] = useState(item[editSettings.valueField]);

  const renderInput = () => {
    if (editSettings.type === 'boolean') {
      return (
        <CheckboxWrapper
          key={value}
          checked={value}
          onChange={(e) => {
            const newVal = e.target.checked;

            setValue(newVal);
            onEdit(newVal);
          }}
        />
      );
    }

    if (editSettings.type === 'integer') {
      return (
        <TextboxWrapper
          value={value}
          onChange={(e) => {
            const newVal = e.target.value;

            setValue(newVal);
            onEdit(parseInt(newVal, 10) || 0);
          }}
        />
      );
    }

    if (editSettings.type === 'float') {
      return (
        <TextboxWrapper
          value={value}
          onChange={(e) => {
            const newVal = e.target.value;

            setValue(newVal);
            onEdit(parseFloat(newVal, 10) || 0);
          }}
        />
      );
    }

    return null;
  };

  return (
    <div>{renderInput()}</div>
  );
};

export { EditDataColumn };
